export default "__VITE_ASSET__BnnaI0I3__"